<template>
  <div>
    <button class="flex w-full text-left dark:text-gray-500 text-gray-800 bg-transparent rounded-md box-border" :aria-expanded="isOpen" :aria-controls="`collapse${_uid}`" @click="toggleAccordion">
      <span class="mr-3 text-xl">
        <slot name="icon" />
      </span>
      <span class="w-full"><slot name="title" /></span>
      <span
        class="mt-1 text-gray-500 dark:text-gray-500 box-border transition-transform duration-300"
        :class="{
          'rotate-180': isOpen,
          'rotate-0': !isOpen,
        }"
      >
        <span class="float-right">
          <Icon icon="fa6-solid:angle-down" color="white" />
        </span>
      </span>
    </button>
    <transition name="expand" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave" @leave="leave" @after-leave="afterLeave">
      <div v-show="isOpen" :id="`collapse${_uid}`" class="overflow-hidden">
        <div class="dark:bg-white-200 mt-2 p-2 bg-nafa_blue_shade_secondary rounded-md">
          <slot name="content" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue'

export default {
  components: {
    Icon,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: this.active,
    }
  },

  watch: {
    active: {
      immediate: true,
      handler(newValue) {
        this.isOpen = newValue
      },
    },
  },

  methods: {
    toggleAccordion() {
      this.$emit('toggle')
    },

    beforeEnter(element) {
      element.style.height = '0'
    },

    enter(element) {
      const height = element.scrollHeight
      element.style.height = height + 'px'
    },

    afterEnter(element) {
      element.style.height = 'auto'
    },

    beforeLeave(element) {
      element.style.height = element.scrollHeight + 'px'
      // Force repaint
      element.offsetHeight
    },

    leave(element) {
      element.style.height = '0'
    },

    afterLeave(element) {
      element.style.height = ''
    },
  },
}
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  height: 0;
}
</style>
